export default __webpack_public_path__ + "static/media/LibreBaskerville-Italic.0ebc99f3.ttf";